export default __webpack_public_path__ + "static/media/iconmonstr-media-control-49.a502a603.svg";